// removed by extract-text-webpack-plugin
module.exports = {"heading":"_2WoZlyvbH-kOEWF40tanmY"};


//////////////////
// WEBPACK FOOTER
// ./src/EpicMigration/components/EpicSubscription.scss
// module id = 2909
// module chunks = 0